import React, {Component} from "react";
import {Layout, List, Card, Pagination, message} from "antd";
import {Link} from "react-router-dom";
import Header from "../../components/header";
import LeftNav from "../../components/leftNav";

import {reqSkill} from "../../api/index";
import './skill.less';

const { Content } = Layout;

/**
 * 技能训练的路由组件
 */
export default class Skill extends Component {

    state = {
        total:0,
        totalPage:0,
        page:1,
        size:12,
        skillList:[],
        openKeys: ['sub1'],
        cid:3
    };

    //获取技能训练列表
    getSkillList = async (cid,page,size) => {
        const result = await reqSkill(cid,page,size);
        if(result.code ==='000000') {
            const total = result.data.total;
            const totalPage = result.data.totalPage;
            const page = result.data.page;
            const size = result.data.size;
            const skillList = result.data.rows;
            const res = await reqSkill(cid,1,total);
            if(page === 1) {
                let idArr = '';
                for (let i = 0; i < total; i++) {
                    if(i<total-1){
                        idArr += (res.data.rows[i].id+",");
                    }else{
                        idArr += res.data.rows[i].id;
                    }
                }
                sessionStorage.setItem("idArr",idArr);
            }
            this.setState({
                total:total,
                totalPage:totalPage,
                page:page,
                size:size,
                skillList : skillList,
                cid:cid
            });
        }else {
            message.error(result.msg);
        }
    };

    pageClick = async(page) =>{
        this.getSkillList(this.state.cid, page, 12);
        this.setState({
            page:page
        });
        window.scrollTo(0,0);
    };

    skillDetail = (detailId) => {
        sessionStorage.setItem("detailId",detailId);
        this.props.history.push("/skillDetail");
    };

    itemRender =(current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total)=>{
        return '共'+total+'条记录/每页'+this.state.size+'条';
    };

    toCase = ()=> {
        sessionStorage.setItem("cid",1);
        this.props.history.push("/case");
    };

    componentDidMount = async() =>{
        let cid = sessionStorage.getItem("cid")==null?3:sessionStorage.getItem("cid");
        sessionStorage.setItem("cid",cid);
        this.getSkillList(cid, 1, 12);
        document.getElementsByClassName("logo_t")[0].setAttribute("hidden",true);
    };

    componentWillReceiveProps = async() => {
        let cid= sessionStorage.getItem("cid");
        if(cid!==this.state.cid){
            this.getSkillList(cid, 1, 12);
        }
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {

        const {total,page,skillList,size} = this.state;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftNav>LeftNav</LeftNav>
                    <Content>
                        <div className="tab">
                            <ul>
                                <li className="tab_skill"><Link to='/skill'>技能训练</Link></li>
                                <li className="tab_case"><a onClick={this.toCase.bind(this)}>案例学习</a></li>
                            </ul>
                        </div>
                        <div className="skill">
                            <div className="skill_list">
                                <List
                                    grid={{ column: 4 }}
                                    dataSource={skillList}
                                    renderItem={skillList => (
                                        <List.Item>
                                            <Card>
                                                <img onClick={this.skillDetail.bind(this,skillList.id)} className="skill_img" src={skillList.imgs?global.constant.baseUrl+'download/'+skillList.imgs[0]:require("../../assets/images/head.jpg")}/>
                                                <span className="skill_title">{skillList.title}</span>
                                            </Card>
                                        </List.Item>
                                    )}
                                />
                                <Pagination total={total} pageSize={size} current={page} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal}/>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}